import { motion } from "framer-motion";
import { Radar, SlidersHorizontal, Radio, MonitorSmartphone, TrendingUp } from "lucide-react";
import { LAYERS } from "@/data/content";

const ICONS = [Radar, SlidersHorizontal, Radio, MonitorSmartphone, TrendingUp];

export default function SystemDiagram({ dark = true }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-3" data-testid="system-diagram">
      {LAYERS.map((layer, i) => {
        const Icon = ICONS[i];
        return (
          <motion.div
            key={layer.id}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="relative border p-5 border-zinc-200 bg-white"
          >
            {i < LAYERS.length - 1 && (
              <span
                className="hidden md:block absolute top-1/2 -right-[13px] w-[14px] h-px bg-signal z-10"
                aria-hidden="true"
              >
                <span className="absolute -right-0.5 -top-[3px] w-1.5 h-1.5 bg-signal rounded-full animate-pulse-dot" style={{ animationDelay: `${i * 0.4}s` }} />
              </span>
            )}
            <div className="flex items-center gap-2.5 mb-4">
              <Icon size={16} className="text-signal" />
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-signal">{layer.id}</span>
              <span className="ml-auto font-mono text-[10px] text-zinc-400">0{i + 1}</span>
            </div>
            <ul className="space-y-2">
              {layer.items.map((item) => (
                <li key={item} className="text-sm text-ink">{item}</li>
              ))}
            </ul>
          </motion.div>
        );
      })}
    </div>
  );
}
